import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchAttendanceLeaveType, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraHoursReport, fetchLeaveBalanceReportRequest, fetchLeaveReportRequest, getMobilePunchReport, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";
import FinancialYearPicker from "common/FinancialYearPicker";


const typeOptions = [
  { label: "with LCF", value: 1 },
  { label: "without LCF", value: 2 }
];

const AttendanceReportLeaveBalance = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    dropdownAutoList,
    designations,
    leaveTypes,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    leaveTypes: state.AttendanceLeaveManagReducer?.leaveTypes ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
    dispatch(fetchDesignations(unitId));
    dispatch(fetchAttendanceLeaveType(unitId))
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      department: "",
      category: "",
      employee: "",
      financialYear: null,
      type: "",
    },
    validationSchema: Yup.object({
      financialYear: Yup.object({
        value: Yup.string().required("Financial Year is required")
      }).nullable().required("Financial Year is required"),
       type: Yup.number()
        .nullable()
        .typeError("Type is required")
        .required("Type is required"),
    }),

    onSubmit: (values) => {
      // console.log("Form Values:", values);
      const formData = new FormData();
      formData.append("dep_id", values.department || 0);
      formData.append("cat_id", values.category || 0);
      formData.append("emp_code", values.employee || 0);
      formData.append("fin_year", values.financialYear?.value || values.financialYear || "");
      formData.append("type", values.type || "");
      formData.append("create_by", authDetails?.user_id);
      formData.append("unit_id", authDetails?.unit_id);

      dispatch(fetchLeaveBalanceReportRequest(formData));
    },
  });

  // const columns = [
  //   {
  //     Header: "Employee Details",
  //     columns: [
  //       { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
  //       { Header: "Emp Code", accessor: "empCode" },
  //       { Header: "Emp Name", accessor: "empName" },
  //       { Header: "Category", accessor: "category" },
  //       { Header: "Department", accessor: "department" },
  //       { Header: "Leave Year", accessor: "leaveYear" },
  //       { Header: "Gender", accessor: "gender" },
  //       { Header: "Experience", accessor: "experience" },
  //       { Header: "ESI Eligible", accessor: "esiEligible" },
  //     ],
  //   },
  //   {
  //     Header: "CL",
  //     columns: [
  //       { Header: "Eligible", accessor: "clEligible" },
  //       { Header: "Availed", accessor: "clAvailed" },
  //       { Header: "Balance", accessor: "clBalance" },
  //     ],
  //   },
  //   {
  //     Header: "SL",
  //     columns: [
  //       { Header: "Eligible", accessor: "slEligible" },
  //       { Header: "Availed", accessor: "slAvailed" },
  //       { Header: "Balance", accessor: "slBalance" },
  //     ],
  //   },
  // ];

  const columns = [
    {
      Header: "Employee Details",
      className: "text-center",
      columns: [
        { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", },
        { Header: "Code", accessor: "emp_code" },
        { Header: "Name", accessor: "emp_name" },
        { Header: "Category", accessor: "category" },
        { Header: "Department", accessor: "department" },
        { Header: "Fin Year", accessor: "leave_year" },
        { Header: "Gender", accessor: "gender" },
        {
          Header: "Experience",
          accessor: "experience",
          Cell: ({ value }) => `${value} Years`,
        },
        {
          Header: "ESI Eligible",
          accessor: "esi_eligible",
          Cell: ({ value }) => (
            <span className={`badge ${value === "Yes" ? "bg-success" : "bg-danger"}`}>
              {value}
            </span>
          ),
          className: "text-center",
        },
      ],
    },

    {
      Header: "CL",
      className: "text-center",
      columns: [
        { Header: "Eligible", accessor: "eligible_cl", Cell: ({ value }) => value ?? 0 },
        { Header: "Availed", accessor: "availed_cl", Cell: ({ value }) => value ?? 0 },
        { Header: "Balance", accessor: "balance_cl", Cell: ({ value }) => value ?? 0 },
      ],
    },

    {
      Header: "SL",
      className: "text-center",
      columns: [
        { Header: "Eligible", accessor: "eligible_sl", Cell: ({ value }) => value ?? 0 },
        { Header: "Availed", accessor: "availed_sl", Cell: ({ value }) => value ?? 0 },
        { Header: "Balance", accessor: "balance_sl", Cell: ({ value }) => value ?? 0 },
      ],
    },
  ];

  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Leave" breadcrumbItem="Leave Balance" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>                

                <Col md={3}>
                  <Label>Department</Label>
                  <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                      value={
                        departments
                          .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                          .find(dept => dept.value === formik.values.department) || null
                      }
                      onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                    />
                </Col>
                <Col md={3}>
                  <Label>
                    Employee
                  </Label>
                  <CustomSelect
                      id="employee"
                      name="employee"
                      options={dropdownAutoList.map(emp => ({
                        value: String(emp.emp_id),
                        label: emp.emp_no
                      }))}

                      // UI needs the object, so find matching option
                      value={
                        dropdownAutoList
                          .map(emp => ({
                            value: String(emp.emp_id),
                            label: emp.emp_no
                          }))
                          .find(option => option.value === formik.values.employee) || null
                      }

                      // Form Data: store string only
                      onChange={(selected) =>
                        formik.setFieldValue("employee", selected ? selected.value : "")
                      }
                    />
                    {formik.touched.employee && formik.errors.employee && (
                      <div className="text-danger">
                        {formik.errors.employee}
                      </div>
                    )}
                </Col>
                <Col md={3}>
                  <Label>
                    Financial Year <span className="text-danger">*</span>
                  </Label>

                  <FinancialYearPicker
                    value={formik.values.financialYear || null}
                    onChange={(val) => formik.setFieldValue("financialYear", val)}
                  />


                  {formik.touched.financialYear && formik.errors.financialYear ? (
                    <div className="text-danger">
                      {formik.errors.financialYear}
                    </div>
                  ) : null}
                </Col>

                <Col md={3}>
                  <Label>Type <span className="text-danger">*</span></Label>
                  <CustomSelect
                    id="type"
                    name="type"
                    options={typeOptions.map(opt => ({ value: opt.value, label: opt.label }))}
                    value={
                      typeOptions
                        .map(opt => ({ value: opt.value, label: opt.label }))
                        .find(opt => opt.value === formik.values.type) || null
                    }
                    onChange={val => formik.setFieldValue('type', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.type && formik.errors.type ? 'is-invalid' : ''}`}
                  />
                  {formik.touched.type && formik.errors.type && (
                    <div className="text-danger">{formik.errors.type}</div>
                  )}
                </Col>
                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 ">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Leave Balance Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Leave Balance Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportLeaveBalance;
